var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.2 18.045c-4.3 0-7.8-3.508-7.8-7.82 0-4.311 3.5-7.819 7.8-7.819s7.8 3.508 7.8 7.82c0 4.311-3.5 7.82-7.8 7.82zm8.219-1.789c1.24-1.694 1.981-3.774 1.981-6.03C20.4 4.587 15.824 0 10.2 0S0 4.587 0 10.226C0 15.864 4.576 20.45 10.2 20.45c2.51 0 4.807-.918 6.584-2.431l4.22 4.23c.235.235.542.353.85.353.306 0 .614-.118.848-.352.469-.47.469-1.23 0-1.701l-4.283-4.294z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search_white.96c247ed5f418eb4fb2764f0356c716d.svg";
export { ForwardRef as ReactComponent };